import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FaviconService {
  private faviconIco = 'favicon.ico'
  private favicon180 = 'favicon180.png'
  private faviconSvg = 'faviconSvg.svg'
  private faviconManifest = 'faviconManifest.webmanifest.json'

  constructor() {}

  private customersWithCustomFavicons = ['overheaddoor', 'wayne-dalton']

  private buildPath(customerKey: string, path: string) {
    return `assets/dynamic-favicons/${customerKey.toLowerCase()}/${path}`
  }

  setFaviconsForCustomer(customerKey: string) {
    if (!this.customersWithCustomFavicons.includes(customerKey)) {
      return;
    }

    this.updateFavicon({
      id: 'faviconIco',
      href: this.buildPath(customerKey, this.faviconIco)
    })
    this.updateFavicon({
      id: 'favicon180',
      href: this.buildPath(customerKey, this.favicon180)
    })
    this.updateFavicon({
      id: 'faviconSvg',
      href: this.buildPath(customerKey, this.faviconSvg)
    })
    this.updateFavicon({
      id: 'faviconManifest',
      href: this.buildPath(customerKey, this.faviconManifest)
    })
  }

  private updateFavicon({ href, id }: { id: string, href: string }) {
    const link: HTMLLinkElement | null = document.getElementById(id) as HTMLLinkElement;

    if (link) {
      link.href = href;
    } else {
      console.error(`Favicon with id ${id} not found`);
    }
  }
}
